
import request from '@/common/ajax'
import $  from 'jquery';
import $config  from '../config/config';
import $active  from './active';
import wxuserUtil from '@/common/wxuserUtil';


/**
 * @name 徕卡学院
 *
 */
import $lkcollege_api  from './lkcollege_api';
/**
 *
 * @name 报表
 *
 */
import $report from './report';
const api= {
  /**
   * 发送同步请求
   * @param arrays
   */
  $active,
  $lkcollege_api,
  ...$report,
  sendSync : function (...arrays) {
    var ret = null;
    $.ajaxSetup({async : false});
    $.ajax({
      type: arrays[2].toUpperCase() || 'POST',
      url: $config.serverURL + arrays[0],
      data: arrays[1] || {},
      dataType: 'json',
      header: arrays[3]||{
        'content-type': 'application/x-www-form-urlencoded'
      },
      success: res => {
        ret = res;
      }
    });
    $.ajaxSetup({async : true});

    return ret;
  },
  upload:function(...arrays) {
    return new Promise(
      (resolve, reject) => {
        $.ajax({
          type: 'POST',
          url: $config.serverURL + arrays[0],
          data: arrays[1] || {},
          dataType: 'json',
          contentType:false,
          processData:false,
          // header: arrays[3]||{
          //     'content-type': 'application/x-www-form-urlencoded'
          // },
          success: res => {
            resolve(res)
          },
          error: err => {
            reject(err)
          }
        });
      }
    )
  },

  /**
   * 发送GET请求
   * @param url
   * @param data
   */
  get(url,data){
    return request(url,data,'GET');
  },

  /**
   * 发送同步的GET请求
   */
  getSync : function (url,data) {
    return this.sendSync(url,data,'GET');
  },

  /**
   * 发送post请求
   * @param url
   * @param data
   */
  post(url,data){
    return request(url,data,'POST');
  },

  /**
   * 发送同步post请求
   * @param url
   * @param data
   */
  postSync(url,data){
    return this.sendSync(url,data,'POST');
  },

  /**
   * 发送post raw请求
   * @param url
   * @param data
   */
  postRaw(url,data){
    return request(url,data,'POST',{
      "Content-Type" : "application/x-www-form-urlencoded"
    });
  },

  /**
   * @param {code}
   * @param {Object}   数据对象
   * 获取企业用户详情信息
   *
   */
   getUserInfo(data){
    return request('api/wxwork/userDetail',data||{},'GET')
  },

  /**
   *
   *  @param {url}
   *  获取企业微信签名
   */
  getWxchartSignature(data){
    return request('api/wxwork/sign',data||{},'GET')
  },

  /**
   *
   *  @param{salesId}  销售用户ID  【首页】
   *  获取菜单列表
   */
  getMenuList(data){
    return request('api/common/menu',data||{},'GET')
  },

  /**
   *
   *  @param{salesId}  销售用户ID  【首页】
   *  获取菜单列表-同步
   */
  getMenuListSync(data){
    return this.getSync('api/common/menu',data||{},'GET')
  },

  /**
   *
   *   获取企业号配置
   *
   */
  getDeploys(data){
    return this.getSync('api/wxwork/config',data||{},'GET')
  },

  /**
   *
   *  查询客户列表
   *
   */
  getClientlist(data){
    return   this.sendSync('api/cust/pageList',data,'GET')
  },

  /**
   *
   *
   *   字典表
   *
   */
  getQueryByTcode(data){
    var params = data||{};
    params = $.extend(true,{
      salesId : wxuserUtil.getUserId()
    },data);
    return   request('api/dict/queryByTcode',params,'GET')
  },
  /**
   *
   *
   *  查询区域
   *
   */
  getLocals(data){
    return   request('api/common/locals',data||{},'GET')
  },
  /**
   *
   *
   *  经销商查询
   *
   */
  getDealerlist(data){
    return   request('api/dealer/list',data||{},'GET')
  },
  /**
   *
   *
   *  销售用户
   *
   */
  getSaleslist(data){
    return   request('api/sales/list',data||{},'GET')
  },
  /**
   *
   *
   *  生成二维码
   *
   */
  getQrcode(data){
    return   $config.serverURL+'api/common/qrcode?content='+data
  },
  /**
   *
   *
   *  文件上传
   *
   */
  uploadFile(data){
    return    this.upload('api/common/upload',data)
  },
  /*每日客流详情*/
  getSalesDetail(data){
    return   request('api/storeVisit/query',data||{},'GET')
  },

  /* 微信的素材id 保存 */
  uploadFileWx(data){
	  return   request('api/common/uploadImg',data||{},'GET')
  },


  /**
   *
   *
   *  提交每日客流
   *
   */
  saveSaleslist(data){
    return   request('api/storeVisit/submit',JSON.stringify(data)||{},'POST')
  },
  /**
   *
   *
   *  客户详情
   *
   */
  getCustDetail(data){
    return   request('api/cust/detail',data||{},'GET')
  },
 /**
  *
  *
  *  客户信息修改
  *
  *
  */
 saveCusetNews(data){
  return   request('api/cust/edit',data||{},'POST')
 },
 /**
  *
  *
  *  客户全部标签
  *
  *
  */
 getTagAlls(data){
   return  request('api/tag/all',data||{},'GET')
 },
 /**
  *
  *  客户标签列表
  *
  */
 getTagListCust(data){
  return  request('api/tag/listCust',data||{},'GET')
 },
 /**
  *
  *  客户标签列表
  *
  */
 getTagListCustPost(data){
  return  request('api/tag/listCust',data||{},'POST')
 },
/**
 *
 *
 *   客户标签更新
 *
 */
setSaveTag(data){
  return  request('api/tag/saveTag',data||{},'GET')
},
/**
 *
 *
 *   客户详情 跟进信息列表
 *
 */
getCustListFollow(data){
  return  request('api/cust/listFollow',data||{},'GET')
},
/**
 *
 *
 *   跟进计划详情
 *
 */
getCustDetailFollow(data){
  return  request('api/cust/detailFollow',data||{},'GET')
},
/**
 *
 *
 *  参与活动列表
 *
 *
 */
joinActivityList(data){
  return  request('api/campaign/queryCustCamp',data||{},'GET')
},
/**
 *
 *
 *  参与课程列表
 *
 */
joinCurriculumList(data){
  return  request('api/cust/listCourse',data||{},'GET')
},
/**
 *
 *
 *  客户问卷调研列表
 *
 *
 */
getCustListSurvey(data){
   return  request('api/cust/listSurvey',data||{},'GET')
},

/**
 *
 *
 *  意向产品新增 修改
 *
 *
 */
custSaveIntentionProd(data){
  return  request('api/cust/saveIntentionProd',data||{},'GET')
},

/**
 *
 *
 *  意向产品列表
 *
 *
 */
custListIntentionProd(data){
  return  request('api/cust/listIntentionProd',data||{},'GET')
},

/**
 *
 *
 *  意向产品详情
 *
 *
 */
custDetailIntentionProd(data){
  return  request('api/cust/detailIntentionProd',data||{},'GET')
},
/**
 *
 *
 * 产品一级分类
 *
 *
 */
getProdQuery1st(data){
  return  request('api/prod/query1st',data||{},'GET')
},
/**
 *
 *
 * 产品二级分类
 *
 *
 */
getProdQuery2st(data){
  return  request('api/prod/query2st',data||{},'GET')
},
/**
 *
 *
 * 产品详情
 *
 *
 */
getProdQueryDetail(data){
  return  request('api/prod/queryDetail',data||{},'GET')
},

/**
 * 产品价格
 */
getProdQueryPrice(data){
  return  request('api/cust/productPrice',data||{},'GET')
},
/**
 *
 *
 *  新增修改 购买产品
 *
 *
 */
 saveSoldProdCusts(data){
  return  request('api/cust/saveSoldProd',data||{},'POST')
 },
/**
 *
 *
 *  产品详情  购买产品
 *
 *
 */

getDetailSoldProdCust(data){
  return  request('api/cust/detailSoldProd',data||{},'GET')
},

/**
 *
 *
 *  通过二维码  查询产品
 *
 *
 */


getDetailSoldProdQrCode(data){
  return  request('api/cust/detailSoldProdQrCode',data||{},'GET')

},

/**
 *
 *
 *  高级筛选   查询全部活动
 *
 *
 */
getCampaignSelete(data){
  return  request('api/common/campaign',data||{},'GET')
},

/**
 *
 *
 *  高级筛选  查询全部课程
 *
 *
 */
getCourseSelete(data){
  return  request('api/common/course',data||{},'GET')
},
/**
 *
 *
 *  根据货号 是否有序号
 *
 *
 */
getQueryExistSerial(data){
  return  request('api/prod/queryExistSerial',data||{},'GET')
},
/**
 *
 *
 *  新增&更新跟进计划
 *
 *
 */
getCustSaveFollow(data){
  return  request('api/cust/saveFollow',data||{},'GET')
},
/**
 *
 *
 *  已购买产品列表
 *
 *
 */
getCustListSoldProd(data){
  return  request('api/cust/listSoldProd',data||{},'GET')
},
/**
 *
 *
 *  销售顾问
 *
 *
 */
getSalesLists(data){
  return  request('api/sales/list',data||{},'GET')
},
/**
 *
 *
 *  客户分派
 *
 *
 */
 saveCustDispatch(data){
  return  request('api/cust/dispatch',data||{},'GET')
 },

 /**
  *
  *
  *  新增客户
  *
  */
  saveCustAdd(data){
    return  request('api/cust/add',data||{},'GET')
  },
  /**
   *
   *
   * 手机号码验证
   *
   *
   */
   getCustValidatorMobile(data){
    return  request('api/cust/validatorMobile',data||{},'GET')
   },
  /**
   *
   *
   * 工作台数量
   *
   *
   */
  queryWorkBenchCnt(data){
    return  request('api/sales/queryWorkBenchCnt',data||{},'GET')
  },

/**=======================   课程接口  =========================**/
getCourseList(data){   //课程列表
  return   this.sendSync('api/course/list',data,'GET')
},
getCourseTeacherInfo(data){ //导师
  return  request('api/course/teacherInfo',data||{},'GET')
},
saveCourseSaves(data){  //新增课程 编辑课程
  return  request('api/course/save',data||{},'POST')
},
getCourseDetails(data){ //课程详情
  return  this.sendSync('api/course/detail',data,'POST')
},
cancelCourses(data){  // 取消原因
  return  request('api/course/cancel',data||{},'POST')
},
getCourseDetailWorks(data){ //作品详情
  return  request('api/course/detailWorks',data||{},'POST')
}, // 作品提交
saveWorksReviewCourse(data){
  return  request('api/course/saveWorksReview',data||{},'POST')
},
getCalendarCourseView(data){
  return  request('api/course/view',data||{},'GET')
},// 活动查看作品详情
getCampaignDetailWorks(data){
  return  request('api/campaign/detailWorks',data||{},'GET')
},// 活动作品提交接口
saveWorksReviewCampaigns(data){
  return  request('api/campaign/saveWorksReview',data||{},'GET')
},

/******客户360接口******/
getClientByExtUserId(data){   //课程列表
  return request('api/cust/queryByExtUid',data||{},'POST')
},


}

export default api

/***
 * get 参数转换
 * @param obj
 * @returns {string}
 */
export const paramsConvert = (obj) => {
  let str = [];
  for(let p in obj)
    if (obj.hasOwnProperty(p)) {
      if(typeof(obj[p]) == 'object') {
        for(let cp in obj[p])
          if (obj[p].hasOwnProperty(cp)) {
            str.push(encodeURIComponent(p)+"."+ encodeURIComponent(cp)+ "=" + encodeURIComponent(obj[p][cp]));
          }
      }else if(obj[p] != undefined){
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    }
  return str.join("&");
};



// WEBPACK FOOTER //
// ./src/api/api.js